<script setup lang="ts">
const target = ref<HTMLElement | null>(null)

onMounted(() => {
  target.value = document.getElementById('brand-app-editor-footer')
})
</script>

<template>
  <Teleport :to="target ?? 'body'" :disabled="!target">
    <div
      class="border-border bg-background flex shrink-0 items-center justify-end gap-2 border-t px-6 py-4"
      :class="!target && 'sticky -bottom-6 -mb-6'"
    >
      <slot />
    </div>
  </Teleport>
</template>
